<template>
  <!-- Hidden on a phone, where only cards fit -->
  <View v-if="!screenMobile" gap="xs" role="group" aria-label="View">
    <IconButton
      icon="grid-01"
      size="medium"
      :variant="view === 'cards' ? 'secondary' : 'outline'"
      aria-label="Cards"
      :aria-pressed="view === 'cards'"
      data-testid="view-cards"
      @click="setView('cards')"
    />
    <IconButton
      icon="menu-01"
      size="medium"
      :variant="view === 'table' ? 'secondary' : 'outline'"
      aria-label="Table"
      :aria-pressed="view === 'table'"
      data-testid="view-table"
      @click="setView('table')"
    />
  </View>
</template>

<script setup lang="ts">
import { IconButton, View, screenMobile } from '@tallo/design-system';

import { ListViewList, useListView } from '../composables/list-view';

/** Cards or rows for the list beside it; each list keeps its own choice */
const props = defineProps<{ list: ListViewList }>();

const { view, setView } = useListView(props.list);
</script>
